export function trackElapsedTime() {
  const startTimestamp = Date.now();

  function getTimeElapsed() {
    return Date.now() - startTimestamp;
  }

  return {
    getTimeElapsed,
  };
}
